import { useEffect, useState } from 'react'
import { QueryStatus, QueryStatusType } from 'src/types'
import {HttpCLFB} from "../api/HttpCLFB";
import {OperacionCLFB} from "../types/types";

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionCLFB: (idOperacion: number) => UseOperacionResult<OperacionCLFB> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionCLFB>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpCLFB.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
